import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface CompanySuggestion {
  linkedin_internal_id: string;
  name: string;
  tagline: string;
  profile_pic_url: string;
  urn: string;
  universal_company_link: string;
}

export const useCompanySuggestions = (searchTerm: string) => {
  const [suggestions, setSuggestions] = useState<CompanySuggestion[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchSuggestions = async () => {
      if (searchTerm.length < 1) {
        setSuggestions([]);
        return;
      }

      setLoading(true);
      const { data, error } = await supabase
        .from('linkedin_company_lookup')
        .select('*')
        .ilike('name', `${searchTerm}%`)
        .limit(5);

      setLoading(false);
      if (error) {
        console.error('Error fetching company suggestions:', error);
        return;
      }

      setSuggestions(data);
    };

    fetchSuggestions();
  }, [searchTerm]);

  return { suggestions, loading };
};